import { Button } from "@mui/material";
import { Spinner } from "react-bootstrap";
import "./AppButton.style.css";

const AppButton = ({
  children,
  OnPress,
  Style,
  BtnStyle,
  Type,
  Color,
  Size,
  IsDisabled,
  ClassName,
  Variant,
  SX,
  LoadingState,
}) => {
  const BtnColorProps = Color && Color.includes("#") ? {} : { color: Color };

  return (
    <div style={{...Style }} className="w-100">
      <Button
        type={Type ? Type : "button"}
        style={{ ...BtnStyle, borderRadius: "4px", minHeight: '39px' }}
        onClick={OnPress}
        className={`${
          Color && Color === "error"
            ? "custom-app-button-error"
            : "custom-app-button-theme"
        } ${ClassName}`}
        sx={{
          textTransform: "none",
          ":disabled": {
            opacity: 0.7
          },
          ...SX,
        }}
        size={Size ? Size : "small"}
        variant={Variant ? Variant : "contained"}
        fullWidth
        disabled={IsDisabled || LoadingState}
        {...BtnColorProps}
      >
        {LoadingState ? (
          <Spinner size="sm" type="border" style={{margin: '3px auto'}} />
        ) : children}
      </Button>
    </div>
  );
};

export default AppButton;
